import { render, staticRenderFns } from "./FriendManagementGroupSectionEditor.vue?vue&type=template&id=00bfd3b6&scoped=true"
import script from "./FriendManagementGroupSectionEditor.vue?vue&type=script&lang=ts"
export * from "./FriendManagementGroupSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./FriendManagementGroupSectionEditor.vue?vue&type=style&index=0&id=00bfd3b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bfd3b6",
  null
  
)

export default component.exports